import React, {PropTypes, Component} from "react";
import {inject, observer} from "mobx-react";
import {Form} from 'reactstrap';
import DataWrapper from "../../../principal/containers/DataWrapper";
import _ from 'lodash';
import PagamentoStore from "../stores/PagamentoStore";
import ParametrosGeraisStore from "../../../administracao/stores/ParametrosGeraisStore";
import {Redirect} from "react-router-dom";
import {FormWithActions} from "../../../comum/components/FormWithActions";
import {LoadingPanel} from "../../../comum/components/LoadingPanel";
import {NotaFiscalForm} from "../components/NotaFiscalForm";
import {DetalhamentoPagamento} from "../components/DetalhamentoPagamento";
import {DetalhamentoTabelaMots} from "../components/DetalhamentoTabelaMots";

@inject("store")
@DataWrapper
@observer
export class EnvioPagamento extends Component {
    constructor(props) {
        super(props);
        this.state = this.props.store.appStore;
        this.loginStore = this.props.store.loginStore;
        this.formStore = this.props.store.formStore;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
        this.validacaoStore = this.props.store.validacaoStore;
        this.modalStore = this.props.store.modalStore;
        this.loadingPanelStore = this.props.store.loadingPanelStore;

        this.controller = new PagamentoStore(this.validacaoStore, this.loadingPanelStore);


    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Pagamento");

        this.controller.carregarDados(_.get(this.props, "match.params.id"));
    }

    static propTypes = {
        label: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.array,
            PropTypes.object,
        ])
    };


    render() {
        if (this.formStore.acaoEnviada) {
            return <Redirect to="/pagamentos-pendentes"/>;
        } else {
            return this.renderForm();
        }
    }

    renderForm() {
        return (
            <div>
                <div className="form-wrapper">
                    <LoadingPanel>
                        <div className="content-panel panel-sm">
                            <Form className="panel-form">
                                <FormWithActions controller={this.controller}
                                                 taskId={_.get(this.props, "match.params.id")}
                                                 possiveisAcoes={this.controller.possiveisAcoes}
                                                 error={this.formStore.submitted && !this.modalStore.exibirModal.aberto && !this.validacaoStore.isValidForm}>
                                    <NotaFiscalForm/>
                                    <DetalhamentoPagamento/>
                                    <DetalhamentoTabelaMots/>
                                </FormWithActions>
                            </Form>
                        </div>
                    </LoadingPanel>
                </div>
            </div>
        )
    }
}